import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PriceSection } from './components/PriceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { SocialProofPopups } from './components/SocialProofPopups';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showSocialProof?: boolean;
}
export function App({
  showSocialProof = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full min-h-full bg-white font-sans text-gray-900" data-id="element-0" data-mp="28tmej1rry8wp">
      <UrgencyBar data-id="element-1" data-mp="23vkvuhy9gblr" />
      <main data-id="element-2" data-mp="23w4g45bdvc2y">
        <Hero data-id="element-3" data-mp="23u9q4cl98ts0" />
        <HookSection data-id="element-4" data-mp="23utb6267bya9" />
        <TomosSection data-id="element-5" data-mp="23t8eo70bu59r" />
        <BonusSection data-id="element-6" data-mp="3ik7fce9tu7pl" />
        <PriceSection data-id="element-7" data-mp="3ikqwhsrnks2k" />
        <GuaranteeSection data-id="element-8" data-mp="3ijfv1zlojwem" />
        <FaqSection data-id="element-9" data-mp="3ii4s22026sok" />
        <FinalCtaSection data-id="element-10" data-mp="3mlax56bfqdtg" />
      </main>
      <Footer data-id="element-11" data-mp="3mk84asujy1aw" />
      {showSocialProof && <SocialProofPopups data-id="element-12" data-mp="3mj6hxs835sdv" />}
    </div>;
}